import { useEffect, useState } from 'react';
import { getTimezone } from 'countries-and-timezones';
export function useUserLocation() {
  const defaultCode = 'US';
  const defaultOffset = '+3';
  const [location, setLocation] = useState({
    country: defaultCode,
    offset: defaultOffset,
  });

  useEffect(() => {
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const tzData = getTimezone(tz);
      const formattedOffset = tzData.utcOffsetStr;
      const country = tzData.countries[0] || defaultCode;
      setLocation({
        country,
        offset: formattedOffset,
        timezoneData: tzData,
      });
    } catch (err) {
      setLocation({ country: defaultCode, offset: defaultOffset });
    }
  }, []);

  return location;
}
